@if (!TabCategory) {
  @if (Home && !Merchant.multi_outlet && (About || (!Product && Category))) {
    <div class="Homebanner" [ngStyle]="{
            'background-image':
              'url(' + Merchant.webapp_settings?.all_page_banner_image + ')',
            'border-bottom':
              Merchant.webapp_settings?.menu_border_width +
              'px solid ' +
              Merchant.webapp_settings?.menu_border_color,
      }"
    ></div>
  }

  @if (Home && !Merchant.multi_outlet && !About && !Product && !Category) {
    <div class="Homebanner" [ngStyle]="{
            'background-image':
              'url(' + Merchant.webapp_settings?.all_page_banner_image + ')',
            'border-bottom':
              Merchant.webapp_settings?.menu_border_width +
              'px solid ' +
              Merchant.webapp_settings?.menu_border_color,
      }"
    ></div>
  }

  @if (Home && Merchant.multi_outlet && (About || (!Product && Category))) {
    <div class="Homebanner" [ngStyle]="{
            'background-image': 'url(' + Merchant?.headerImage + ')',
            'border-bottom':
              Merchant.menu_border_width + 'px solid ' + Merchant.menu_border_color,
      }"
    ></div>
  }

  @if (Home && Merchant.multi_outlet && !About && !Product && !Category) {
    <div class="Homebanner" [ngStyle]="{
            'background-image': 'url(' + Merchant?.headerImage + ')',
            'border-bottom':
              Merchant.menu_border_width + 'px solid ' + Merchant.menu_border_color,
      }"
    ></div>
  }

  @if (!Home && !Merchant.multi_outlet && (About || (!Product && Category))) {
    <div class="banner inner-banner" [ngStyle]="{
            'background-image':
              'url(' + Merchant.webapp_settings?.all_page_banner_image + ')',
            'border-bottom':
              Merchant.webapp_settings?.menu_border_width +
              'px solid ' +
              Merchant.webapp_settings?.menu_border_color,
      }"
    ></div>
  }

  @if (
    !Home &&
    !Merchant.multi_outlet &&
    !About &&
    !Product &&
    !Category &&
    !Basket &&
    !PaymentScreen
  ) {
    <div class="banner inner-banner" [ngStyle]="{
            'background-image':
              'url(' + Merchant.webapp_settings?.all_page_banner_image + ')',
            'border-bottom':
              Merchant.webapp_settings?.menu_border_width +
              'px solid ' +
              Merchant.webapp_settings?.menu_border_color,
      }"
    ></div>
  }

  @if (
    !Home && !Merchant.multi_outlet && (Product || Basket || PaymentScreen)
  ) {
    <div class="banner inner-banner black-header" [ngStyle]="{
            'border-bottom':
              Merchant.webapp_settings?.menu_border_width +
              'px solid ' +
              Merchant.webapp_settings?.menu_border_color,
      }"
    ></div>
  }

  @if (!Home && Merchant.multi_outlet && (About || (!Product && Category))) {
    <div class="banner inner-banner" [ngStyle]="{
            'background-image': 'url(' + Merchant.bannerImage + ')',
            'border-bottom':
              Merchant.menu_border_width + 'px solid ' + Merchant.menu_border_color,
      }"
    ></div>
  }

  @if (!Home && Merchant.multi_outlet && !About && !Product && !Category) {
    <div class="banner inner-banner" [ngStyle]="{
            'background-image': 'url(' + Merchant.bannerImage + ')',
            'border-bottom':
              Merchant.menu_border_width + 'px solid ' + Merchant.menu_border_color,
      }"
    ></div>
  }
}

<!--
@if (Home && !Merchant.multi_outlet) {
<div class="Homebanner"
  [ngStyle]="{'background-image': 'url(' + Merchant.webapp_settings?.all_page_banner_image + ')','border-bottom' : Merchant.menu_border_width + 'px solid ' + Merchant.webapp_settings?.menu_border_color}">
</div>
}
@if (Home && Merchant.multi_outlet) {
<div class="Homebanner"
  [ngStyle]="{'background-image': 'url(' + Merchant?.headerImage + ')','border-bottom' : Merchant.menu_border_width + 'px solid ' + Merchant?.menu_border_color}">
</div>
}
@if (!Home && !Merchant.multi_outlet) {
<div class="banner inner-banner"
  [ngStyle]="{'background-image': 'url(' + Merchant.webapp_settings?.all_page_banner_image + ')','border-bottom' : Merchant.menu_border_width + 'px solid ' + Merchant.menu_border_color}">
</div>
}
@if (!Home && Merchant.multi_outlet) {
<div class="banner inner-banner"
  [ngStyle]="{'background-image': 'url(' + Merchant.bannerImage + ')','border-bottom' : Merchant.menu_border_width + 'px solid ' + Merchant.webapp_settings?.menu_border_color}">
</div>
} -->
